import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FlexPanel.module.scss';

export const FlexPanel = props => (
  <div
    style={props.style}
    className={classNames(styles['flex-panel'], {
      [styles['flex-panel-spread']]: props.spread,
      [props.className]: props.className
    })}
  >
    {props.children}
  </div>
);

FlexPanel.propTypes = {
  spread: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};
